import React, { useEffect, useImperativeHandle, useState, Fragment, useContext } from 'react';

import {
    customHeaderStyle, defaultPaginationOptions,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle, TableActionIconGeneric
} from "root/Tables/BaseTableComponents";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { runReport } from "root/Tables/ProviderReportHelper";
import { Link } from "react-router-dom";
import GlobalContext, { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const TableUnsubmittedSurveys = ( { data, survey_type} ) =>
{
    const linkFormatter = (cell, row) => {

        const url = '/school/' + row.provider_id + '/year/current/section' ;
        const detailURL = '/school/' + row.provider_id + '/detail' ;

        const { getCustomObject } = useGlobalContext() ;
        const pdfParams = getCustomObject ( ConfigOptions.PDF_PARAMETERS )

        return (
            <Fragment>
                <TableActionIconGeneric to={detailURL} placement='top' text='View School Details' style={{paddingLeft: '10px'}} icon='bi bi-eye-fill' color='var(--s360-icon-green)'/>
                <TableActionIconGeneric to={url} placement='top' text='View Questions' style={{paddingLeft: '10px'}} icon='bi bi-arrow-right-square' color='#E7BF02'/>
                <TableActionIconGeneric onClick={() => runReport(row.provider_id, row.provider_name, 'current', survey_type, false, pdfParams )} style={{paddingLeft: '8px'}} icon='bi bi-filetype-pdf' text='View ACTIONS PDF Report'/>
                <TableActionIconGeneric onClick={() => runReport(row.provider_id, row.provider_name, 'current', survey_type, true, pdfParams)} style={{paddingLeft: '8px'}} icon='bi bi-filetype-pdf' text='View FULL PDF Report'/>
            </Fragment>
        );
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: {...defaultTableHeaderStyles, fontSize: '16px'},
        establishment_number: {borderRadius: defaultTopLeftCellStyle, width: "8vw"},
        provider_name: {width: "24vw"},
        firstname:{width: "18vw"},
        email:{width: "7vw"},
        actions: {borderRadius: defaultTopRightCellStyle, width: "12vw", textAlign: 'center'},
    });

    const schoolFormatter = ( cell, row, rowIndex, formatExtraData ) =>
    {
        const detailURL = '/school/' + row.provider_id + '/detail' ; ;

        return <Link to={detailURL} style={{textDecoration: 'none'}}>{cell}</Link>
    }

    const nameFormatter = ( cell, row, rowIndex, formatExtraData ) =>
    {
        const surname = row.surname ?? '' ;

        return row.firstname + ' ' + surname ;
    }

    const getColumns = () =>
    {
        let columns = [];

        columns.push({
            dataField: 'establishment_number',
            text: 'School ID',
            sort: true,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'provider_name',
            text: 'School Name',
            formatter: schoolFormatter,
            sort: true,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'firstname',
            text: 'Primary DSL',
            formatter: nameFormatter,
            sort: true,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'email',
            text: 'Email',
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'actions',
            text: 'View',
            formatter: linkFormatter,
            headerStyle: headerStyle
        });

        return columns;
    }

    const translations = xlateBootstrapTableColumns(getColumns());

    const columns = React.useMemo(() => translations, []);

    const tableContent = () =>
    {
        return <PassportTable data={data.data} isLoading={data.loading} columns={columns} pagination={defaultPaginationOptions} showSearch={true}/>
    }

    return data.loading === true ? <SpinnerDiv/> : tableContent();
}

export default TableUnsubmittedSurveys;
